<template>
  <div>
    <x-table
      listApi="biz.warehouse.goods.receipt.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无记录信息"
      :fieldList="fieldList"
      :defaultParams="defaultParams"
      :actionWidth="100"
    >
      <template slot="row-info" slot-scope="scope">
        <div style="color: #919191; font-size: 14px">
          <span> 记录时间: </span>
          <span style="color: #333333">
            {{ new Date(scope.row.createTime).format("YYYY-MM-dd hh:mm:ss") || "" }}
          </span>
        </div>
        <div style="color: #919191; font-size: 14px" @click="clickShowZsmList">
          <span> 记录类型: </span>
          <span style="color: #333333; font-size: 16px">
            {{ getReceiptTypeLabel(scope.row) }}
          </span>
        </div>
        <div style="color: #919191; font-size: 14px">
          <span> 经手人员: </span>
          <span style="color: #333333; font-size: 16px">
            {{ scope.row.handledBy }}
          </span>
        </div>
        <div
          style="color: #919191; font-size: 14px"
          v-if="showZsmList && !!scope.row.goodsZsmList"
        >
          <span> 追溯码值: </span>
          <span style="color: #333333">
            {{ scope.row.goodsZsmList }}
          </span>
        </div>
      </template>
    </x-table>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        optCancel: 0,
        storeGuid: this.pageParams.storeGuid,
        goodsGuid: this.pageQuery.guid,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    clickShowZsmList() {
      this.showZsmList = !this.showZsmList;
    },
    getReceiptTypeLabel(item) {
      if (!item) {
        return "";
      }
      if (item.receiptType === "stock_inbound") {
        return "库存-入库";
      } else if (item.receiptType === "stock_outbound") {
        return "库存-出库";
      } else if (item.receiptType === "split_consume") {
        return "拆零-拆耗";
      } else if (item.receiptType === "split_output") {
        return "拆零-拆出";
      } else if (item.receiptType === "sheet_inbound") {
        return "盘点-入库";
      } else if (item.receiptType === "sheet_outbound") {
        return "盘点-出库";
      } else if (item.receiptType === "replenish_outbound") {
        return "调货-出库";
      } else if (item.receiptType === "replenish_inbound") {
        return "补货-入库";
      } else if (item.orderType === "purchase_inbound") {
        return "采购-入库";
      } else if (item.receiptType === "order_sale") {
        return "订单-售出";
      } else if (item.receiptType === "order_return") {
        return "订单-退货";
      }
      return item.receiptType;
    },
  },
  data() {
    return {
      showZsmList: false,
      fieldList: [
        {
          label: "记录信息",
          minWidth: "220",
          slot: "info",
        },
        {
          label: "记录数量",
          width: "120",
          render: (row) => row.receiptCount,
        },
      ],
    };
  },
};
</script>
